import React from "react";

type Props = {
  name: string,
  label?: string,
  placeholder?: string,
  required?: boolean,
  value?: string,
  onChange: (e: any) => void,
  readOnly?: boolean
}

const TextInput : React.FC<Props> = ({
  name,
  label = name,
  placeholder = "",
  required = false,
  value = "",
  onChange,
  readOnly = false
}) => {
  var inputClasses = `text-input ${readOnly ? "text-input-readonly" : ""}`;
  return (
    <div className="form-input-wrapper">
      <label
        className="text-input__label form-label label-input"
        htmlFor={name}
      >
        {label}
      </label>

      <input
        className={inputClasses}
        type="text"
        name={name}
        id={name}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
      />
    </div>
  );
};

export default TextInput;
